<template>
    <section>
        <div class="container container--fluid">
            <v-card>
                <v-card-title class="headline">
                    {{$t('subscription_list_title')}}
                    <v-spacer></v-spacer>
                    <v-btn
                            small
                            color="primary"
                            class="white--text"
                            @click="showForm()"
                    >
                        {{$t('create')}}
                        <v-icon right dark>mdi-plus</v-icon>
                    </v-btn>
                    <v-btn
                            icon
                            small
                            @click="fetch()"
                    >
                        <v-icon right dark>mdi-reload</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-subtitle>{{$t('subscription_list_subtitle')}}</v-card-subtitle>
                <v-divider></v-divider>
                <v-data-table
                        class="text-capitalize"
                        :headers="headers"
                        :items="items"
                        :loading="loading"
                        :options.sync="options"
                        :server-items-length="total"
                        :page="options.page"
                        :items-per-page="options.itemsPerPage"
                        :footer-props="footerProps"
                >
                    <template v-slot:top>
                        <div class="d-flex justify-start mb-6">

                        </div>

                    </template>
                    <template #item.user_id="{item}">
                        <span>
                            {{ item.user_fullname}} {{item.user_mobile}}
                        </span>
                    </template>
                    <template #item.subscription_class="{item}">
                        {{item.subscription_class.name}}
                    </template>
                    <template #item.created_at="{item}">
                        {{ getJalaliDate(item.created_at * 1000) }}
                    </template>
                    <template #item.expired_at="{item}">
                        <v-chip
                                v-if="subscriptionExpiredCheck(item)"
                                color="error"
                                small
                        >{{$t('subscription_expired')}} {{getJalaliDate(item.expired_at * 1000)}}</v-chip>
                        <span v-else>{{getJalaliDate(item.expired_at * 1000)}}</span>
                    </template>
                    <template #item.sent_count="{item}">
                        <v-chip
                                v-if="item.sent_count >= item.limitation_send"
                                color="error"
                                small
                        >{{$t('subscription_complete_consumed')}}</v-chip>
                        <span v-else>{{item.sent_count}}</span>
                    </template>
                    <template #item.actions="{item}">
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon small :loading="updateFaxCountSubscriptionId == item.id" @click="syncFaxCount(item.id)" v-bind="attrs" v-on="on">
                                    <v-icon>mdi-reload</v-icon>
                                </v-btn>
                            </template>
                            <span>بروزرسانی تعداد ارسال ها</span>
                        </v-tooltip>
                        <v-tooltip top v-if="true || userCan('faxes_list')">
                            <template v-slot:activator="{ on, attrs }">
                                <router-link
                                        :to="{name : 'FaxesList', query : { filters : [{column_name : 'subscription_id', operand : 'IsEqualTo', value : item.id}]}}"
                                        class="no-decoration"
                                >
                                    <v-icon v-bind="attrs"
                                            v-on="on"
                                    >mdi-inbox-arrow-up</v-icon>
                                </router-link>

                            </template>
                            <span>{{$t('sent_faxes_list')}}</span>
                        </v-tooltip>
                    </template>
                </v-data-table>
            </v-card>
        </div>

        <Form
                v-if="item"
                :item="item"
                @close="item = null"
                @submit="fetch"
        />
    </section>
</template>

<script>
    import RequestList from "../services/RequestList";
    import Service from "../services/SubscriptionService";
    import Form from "../components/SubscriptionForm";
    import CRUDMixin from '../mixins/CRUDMixin'

    export default {
        mixins : [CRUDMixin],

        components : {
            Form
        },
        watch: {
            dialog (val) {
                !val && this.close()
            },
            filters: {
                handler(filters) {
                    let filtersQuery = [];


                    Object.values(filters).map( filter => {
                        if(filter.value){
                            filtersQuery.push({...filter});
                        }
                    });

                    this.$router.push({
                        query : {
                            filters : filtersQuery,
                            page : 1,
                            count : this.options.itemsPerPage
                        }
                    }).catch(err => err);
                },
                deep: true,
            },
        },
        data() {
            return {
                logsSeen : {},
                dialog : false,
                loading : false,
                logDetails : null,
                updateFaxCountSubscriptionId : null,
                headers : [
                    {
                        text: this.$t('user'),
                        value: 'user_id',
                    },
                    {
                        text: this.$t('subscription_class'),
                        value: 'subscription_class',
                    },
                    {
                        text: this.$t('created_at'),
                        value: 'created_at',
                    },
                    {
                        text: this.$t('expired_at'),
                        value: 'expired_at',
                    },
                    {
                        text: this.$t('limitation_send_table'),
                        value: 'limitation_send',
                    },
                    {
                        text: this.$t('sent_count'),
                        value: 'sent_count',
                    },
                    {
                        text: this.$t('action'),
                        value: 'actions',
                    }
                ],
                filters : {
                    number : {
                        column_name : 'number',
                        operand : 'Contains',
                        value : undefined
                    },
                    state : {
                        column_name : 'state',
                        operand : 'IsEqualTo',
                        value : undefined
                    },
                    zone : {
                        column_name : 'zone',
                        operand : 'IsEqualTo',
                        value : undefined
                    },
                    fax_channel_id : {
                        column_name : 'fax_channel_id',
                        operand : 'IsEqualTo',
                        value : undefined
                    },
                    user_id : {
                        column_name : 'user_id',
                        operand : 'IsEqualTo',
                        value : undefined
                    },
                },
                items : [],
                item : null,
            }
        },
        methods: {
            async fetch() {
                this.loading = true;
           
                let page = this.$route.query.page || 1;
                let count = this.$route.query.count || this.options.itemsPerPage;

                let requestList = new RequestList();

                requestList.setFilters(this.$route.query.filters || []);
                requestList.addOrder('id','desc');
                requestList.setPage(page, count);

                try {
                    let {data} = await Service.list(requestList);
                    this.items = data.value.subscriptions;
                    this.total = data.value.total;
                } finally {
                    this.loading = false;
                }
            },
            subscriptionExpiredCheck(subscription){
                return (new Date()).getTime() >= (subscription.expired_at * 1000);
            },
            showForm(item) {
                item = item || Service.getDefault();
                this.item = item;
            },
            async syncFaxCount(subscriptionId){
                this.updateFaxCountSubscriptionId = subscriptionId;
                try{
                    await Service.updateFaxCount(subscriptionId);
                    this.fetch();
                }finally{
                    this.updateFaxCountSubscriptionId = null;
                }
            }

        }
    }
</script>